export default __webpack_public_path__ + "static/media/RYS_2294.61d605ab.jpg";